
@if ((NewFile!==null && NewFile != ItemData) || buttonName!==buttonNameInit) {
    <p class="not-saved-block">Изменения не сохранены</p>
}
@if (isLoading) {
    <div><app-preloader></app-preloader></div>
}

@if (!isLoading) {
    <div>
        @if (ItemData || NewFile) {
            <div class="content-wrapper">
                @if (!NewFile) {
                    <div class="download-button" (click)="GetFile();$event.stopPropagation()">
                        {{buttonNameInit||'Скачать файл'}}
                    </div>
                }
                @if (NewFile) {
                    <div class="download-button" (click)="download();$event.stopPropagation()">
                        {{buttonNameInit||'Скачать файл'}}
                    </div>
                }
                @if (isDownload) {
                    <app-preloader></app-preloader>
                }
            </div>
        }

        @if (!ItemData && !NewFile) {
            <p class="no-file">Нет файла</p>
        }

        @if (IsSelected) {
            <div>
                <br>
                <div class="name" (click)="$event.stopPropagation()">
                    <input class="form-input" [(ngModel)]="buttonNameInit" placeholder="Введите название кнопки">
                </div>
                <div class="file-wrapper" (click)="$event.stopPropagation()">
                    <input
                            [id]="'file'+ItemUid"
                            type="file"
                            (change)="ChangeItemFile($event.target)"
                    >
                    <label [for]="'file'+ItemUid">
                        <div class="label-content">
                            <img src="assets/icons/download.svg"> Загрузить файл
                        </div>
                    </label>
                </div>
                <div class="buttons" (click)="Save()">
                    <button class="btn-custom btn-active btn-xl">Сохранить</button>
                </div>
            </div>
        }
    </div>
}
